import React from "react";
import RaindropToggle from "../raindrop-toggle/raindrop-toggle.tsx";
import RaindropTextHeading1 from "../raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../raindrop-text-subtitle/raindrop-text-subtitle.tsx";
import FlexCol from "../flex-col/flex-col.tsx";

const RaindropToggleWithTitle = ({
  title = "This is a fake title",
  subtitle = "",
  id = "",
  isDisabled = false,
  initialIsOn = true,
  onToggle = (newIsOn) => {},
}) => {
  return (
    <div className="flex flex-row w-full gap-6 justify-between items-center">
      <FlexCol tailwindGap="gap-0">
        <RaindropTextHeading1 className="w-full">{title}</RaindropTextHeading1>
        {subtitle && (
          <RaindropTextSubtitle className="w-full">
            {subtitle}
          </RaindropTextSubtitle>
        )}
      </FlexCol>

      <RaindropToggle
        id={id}
        isDisabled={isDisabled}
        onToggle={onToggle}
        initialIsOn={initialIsOn}
      />
    </div>
  );
};

export default RaindropToggleWithTitle;
